/**
 * simplebar-vue - v1.6.0
 * Vue component for SimpleBar
 * https://grsmto.github.io/simplebar/
 *
 * Made by Piers Olenski
 * Under MIT License
 */

import 'core-js/modules/es.array.concat';
import SimpleBar from 'simplebar';

//
var script = {
  name: 'simplebar-vue',
  mounted: function mounted() {
    var options = SimpleBar.getOptions(this.$refs.element.attributes);
    this.SimpleBar = new SimpleBar(this.$refs.element, options);
  },
  computed: {
    scrollElement: function scrollElement() {
      return this.$refs.scrollElement;
    },
    contentElement: function contentElement() {
      return this.$refs.contentElement;
    }
  }
};

var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    ref: "element"
  }, [_c("div", {
    staticClass: "simplebar-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c("div", {
    staticClass: "simplebar-mask"
  }, [_c("div", {
    staticClass: "simplebar-offset"
  }, [_c("div", {
    ref: "scrollElement",
    staticClass: "simplebar-content-wrapper"
  }, [_c("div", {
    ref: "contentElement",
    staticClass: "simplebar-content"
  }, [_vm._t("default")], 2)])])]), _vm._v(" "), _c("div", {
    staticClass: "simplebar-placeholder"
  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]);
};

var __vue_staticRenderFns__ = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "simplebar-height-auto-observer-wrapper"
  }, [_c("div", {
    staticClass: "simplebar-height-auto-observer"
  })]);
}, function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "simplebar-track simplebar-horizontal"
  }, [_c("div", {
    staticClass: "simplebar-scrollbar"
  })]);
}, function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "simplebar-track simplebar-vertical"
  }, [_c("div", {
    staticClass: "simplebar-scrollbar"
  })]);
}];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "/Users/adriendenat/Sites/simplebar/packages/simplebar-vue/index.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}
/* style inject */

/* style inject SSR */


var simplebar = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default simplebar;
